import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import Tooltip from '@atlaskit/tooltip';
import { triggerFPNLinkClicked, useCreateFireAnalyticsFromTrigger as useCreateFireAnalyticsFromTriggerDI } from '../../../../common/utils/analytics';
import messages from '../../../../common/utils/i18n/messages';
import { FPNLinkButtonWrapper } from './styled';
var FPNLink = function FPNLink(_ref) {
  var _ref$useCreateFireAna = _ref.useCreateFireAnalyticsFromTrigger,
    useCreateFireAnalyticsFromTrigger = _ref$useCreateFireAna === void 0 ? useCreateFireAnalyticsFromTriggerDI : _ref$useCreateFireAna;
  var intl = useIntl();
  var fireFPNLinkClick = useCreateFireAnalyticsFromTrigger(triggerFPNLinkClicked);
  var handleFPNLinkOpened = function handleFPNLinkOpened() {
    fireFPNLinkClick();
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: intl.formatMessage(messages.fpnLinkTooltipMessage)
  }, /*#__PURE__*/React.createElement(FPNLinkButtonWrapper, {
    "data-testid": "fpn-link-wrapper"
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    target: "_blank",
    href: "https://team.atlassian.com/notifications",
    iconBefore: /*#__PURE__*/React.createElement(ShortcutIcon, {
      label: ""
    }),
    "aria-label": intl.formatMessage(messages.fpnLinkAriaLabel),
    onClick: handleFPNLinkOpened
  })));
};
export default FPNLink;